import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Paper,
  Typography,
  Button,
  Tooltip as BasedTooltip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Menu,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import {
  Help as HelpIcon,
  ContentCopy as CopyIcon,
  Add as AddIcon,
  YouTube as YouTubeIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '30px',
  },
  navigateButton: {
    width: 'fit-content',
    padding: '5px 16px',
    marginBottom: '30px',
    fontSize: '14px',
    backgroundColor: '#5b8d8b',
    borderColor: '#5b8d8b',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#48706f',
    },
    '&.modal': {
      fontSize: '12px',
      borderRadius: '50px',
      marginBottom: 0,
    },
  },
  purchasePanel: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    backgroundColor: '#5b8d8b',
    color: '#fff',
    borderRadius: '4px',
  },
  personalPanel: {
    padding: theme.spacing(2),
    backgroundColor: '#794b6b',
    color: '#fff',
    borderRadius: '4px',
  },
  header: {
    display: 'flex',
  },
  tooltipButton: {
    marginLeft: 'auto',
    marginTop: theme.spacing(-1),
    '& svg': {
      fontSize: '16px',
    },
  },
  purchasedContent: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(0, 2),
    color: '#2b2f2e',
    backgroundColor: '#ffffff',
  },
  purchasedSetsCnt: {
    marginLeft: 'auto',
    padding: '2px 8px',
    backgroundColor: '#b0bcd4',
    fontSize: '12px',
    color: '#fff',
    borderRadius: '50px',
    '& svg': {
      marginLeft: theme.spacing(0.5),
      marginBottom: theme.spacing(-0.25),
      fontSize: '14px',
    },
  },
  purchasedCTA: {
    width: 'fit-content',
    padding: '5px 16px',
    margin: '5px 10px 10px',
    fontSize: '12px',
    borderRadius: '50px',
    textTransform: 'none',
    backgroundColor: '#794b6b',
    borderColor: '#794b6b',
    '&:hover': {
      backgroundColor: '#66445c',
    },
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: '14px',
    },
  },
  linkButton: {
    color: '#586065',
    fontSize: '12px',
    textTransform: 'none',
    '&:hover': {
      color: '#23527c',
      textDecoration: 'underline',
    },
  },
  personalContent: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    color: '#d5bbcd',
    fontSize: '13px',
    backgroundColor: '#5d3451',
  },
  personalActions: {
    display: 'flex',
  },
  whiteButton: {
    marginTop: theme.spacing(3),
    marginLeft: 'auto',
    padding: theme.spacing(0.5, 1),
    backgroundColor: '#fff',
    fontSize: '12px',
    color: '#586065',
    borderRadius: '50px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#fff',
    },
    '& svg': {
      fontSize: '14px',
    },
    '&.modal': {
      marginTop: 0,
      border: 'solid 1px rgba(0, 0, 0, 0.2)',
    },
  },
  helpPanel: {
    borderRadius: '2px',
  },
  helpHeader: {
    padding: theme.spacing(1.5, 1.5, 0, 1.5),
    backgroundColor: '#f9fafc',
    borderBottom: 'solid 1px #eaeef1',
  },
  helpBody: {
    padding: theme.spacing(1.5),
  },
  selectPanel: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2, 3),
    width: 'fit-content',
  },
  newCardModal: {
    '& .MuiDialog-paper': {
      minWidth: '450px',
    },
  },
  modalDescription: {
    display: 'flex',
    marginTop: '16px',
    justifyContent: 'center',
    width: 'fit-content',
    color: '#586065',
    fontSize: '13px',
  },
  sets: {
    backgroundColor: '#f9f9f9',
    padding: '8px 15px',
    margin: '15px 0',
  },
  set: {
    display: 'flex',
    alignItems: 'center',
  },
  setItem: {
    flex: 1,
    color: '#2b2f2e',
    fontSize: '13px',
  },
  dropdown: {
    width: 20,
    height: 30,
    color: '#586065',
  },
  menuItem: {
    fontSize: '13px',
    color: '#333333',
  },
  menuItemIcon: {
    width: '14px',
    marginRight: '4px',
  },
}));

const Tooltip = styled(({ className, ...props }) => (
  <BasedTooltip {...props} classes={{ popper: className }} />
))({
  '& .MuiTooltip-tooltip': {
    maxWidth: 250,
    fontSize: '12px',
  },
});

const NewCardSetModal = ({ open, close, onCreate, cardSet }) => {
  const classes = useStyles();
  const [title, setTitle] = useState(cardSet ? cardSet.title : '');
  const [aim, setAim] = useState(cardSet ? cardSet.aim : '');
  console.log('---', cardSet, title, aim);
  return (
    <Dialog className={classes.newCardModal} open={open}>
      <DialogTitle sx={{ paddingBottom: '0px' }}>New Set</DialogTitle>
      <DialogContent sx={{ paddingBottom: '12px' }}>
        <div>
          <TextField
            label='Title'
            variant='standard'
            sx={{
              minWidth: '350px',
            }}
            placeholder='- Your Title -'
            defaultValue={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className={classes.modalDescription}>
          Final AIM
          <Tooltip
            arrow
            placement='right'
            title='The Final AIM is the target rate of successful views per minute.'
          >
            <IconButton className={classes.tooltipButton}>
              <HelpIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TextField
            variant='standard'
            sx={{ maxWidth: '60px' }}
            onChange={(e) => setAim(e.target.value)}
            defaultValue={aim}
          />
          <Typography sx={{ color: '#586065' }}>per minute</Typography>
        </div>
      </DialogContent>
      <DialogActions sx={{ marginBottom: '12px', marginRight: '24px' }}>
        <Button
          variant='contained'
          disableElevation
          className={`${classes.navigateButton} modal`}
          onClick={() => onCreate(title, aim)}
        >
          Save Changes
        </Button>
        <Button className={`${classes.whiteButton} modal`} onClick={close}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Sets = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [cardSets, setCardSets] = useState([]);
  const [selectedOption, setSelectedOption] = useState(0);
  const [openNewCardModal, setOpenNewCardModal] = useState(false);
  const [isUpdatingCardSet, setIsUpdatingCardSet] = useState(false);
  const [editingIndex, setEditingIndex] = useState();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleUpdateNewCardSet = (title, aim) => {
    const newSets = [...cardSets];

    newSets[editingIndex] = { title, aim };

    setCardSets(newSets);
    setIsUpdatingCardSet(false);
    setOpenNewCardModal(false);
  };

  const handleCreateNewCardSet = (title, aim) => {
    const newSets = [...cardSets];
    newSets.push({ title, aim });
    setCardSets(newSets);
    setIsUpdatingCardSet(false);
    setOpenNewCardModal(false);
  };

  return (
    <div className={classes.root}>
      <Button
        variant='contained'
        disableElevation
        className={classes.navigateButton}
        onClick={() => navigate('/admin')}
      >
        Admin Menu
      </Button>
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <Paper className={classes.purchasePanel}>
            <div className={classes.header}>
              <Typography>Purchased Sets</Typography>
              <Tooltip
                arrow
                placement='left'
                title='This area shows the Fluency FlashCards sets available to you. The Practice Cards will help you become more skilled at using the Fluency FlashCards. Need more help on using these sets? Check out our tutorial videos by clicking the link at left or below.'
              >
                <IconButton className={classes.tooltipButton}>
                  <HelpIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div className={classes.purchasedContent}>
              <Grid container display='flex' alignItems='center' spacing={1}>
                <Grid item xs={2}>
                  Practice Cards
                </Grid>
                <Grid item xs={2}>
                  <span className={classes.purchasedSetsCnt}>
                    35
                    <CopyIcon />
                  </span>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    variant='contained'
                    disableElevation
                    className={classes.purchasedCTA}
                    onClick={() => navigate('/sets/1')}
                  >
                    <CopyIcon />
                    Fluency Cards
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    title='Click to see the daily chart for this test'
                    className={classes.linkButton}
                    href='/sets/1/celeration'
                  >
                    Daily Chart
                  </Button>
                  <Button
                    title='Click to see the timings chart for this test'
                    className={classes.linkButton}
                    href='/sets/1/timing'
                  >
                    Timings
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Paper>
          <Paper className={classes.personalPanel}>
            <div className={classes.header}>
              <Typography>My Personal Sets</Typography>
              <Tooltip
                arrow
                placement='left'
                title='This area shows your own sets of Fluency FlashCards. To add new sets or remove sets, click the Manage My Card Sets button at the very top of your screen. Then, click the Edit button for any set to add, edit and delete cards for that set.'
              >
                <IconButton className={classes.tooltipButton}>
                  <HelpIcon />
                </IconButton>
              </Tooltip>
            </div>
            {cardSets.length > 0 ? (
              <div className={classes.sets}>
                {cardSets.map((cardSet, index) => (
                  <div className={classes.set} key={`card-set-${index}`}>
                    <div className={classes.setItem}>{cardSet.title}</div>
                    <div className={classes.setItem}>
                      <span
                        className={classes.purchasedSetsCnt}
                        style={{ backgroundColor: '#e8ba96' }}
                      >
                        0
                        <CopyIcon />
                      </span>
                    </div>
                    <div className={classes.setItem}></div>
                    <div className={classes.setItem}>
                      --- not enough cards ---
                    </div>
                    <div className={classes.setItem}></div>
                    <Button
                      className={classes.dropdown}
                      sx={{ marginLeft: 'auto' }}
                      onClick={(e) => setAnchorEl(e.currentTarget)}
                    >
                      <ArrowDropDownIcon />
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => setAnchorEl(null)}
                      className={classes.menu}
                    >
                      <MenuItem
                        className={classes.menuItem}
                        onClick={() => {
                          setAnchorEl(null);
                          navigate('/sets/1/timing');
                        }}
                      >
                        <CopyIcon className={classes.menuItemIcon} />
                        Cards
                      </MenuItem>
                      <MenuItem
                        className={classes.menuItem}
                        onClick={() => {
                          setEditingIndex(index);
                          setIsUpdatingCardSet(true);
                          setOpenNewCardModal(true);
                        }}
                      >
                        <UpgradeIcon className={classes.menuItemIcon} />
                        Update
                      </MenuItem>
                      <MenuItem className={classes.menuItem}>
                        <CloseIcon className={classes.menuItemIcon} />
                        Delete
                      </MenuItem>
                    </Menu>
                  </div>
                ))}
              </div>
            ) : (
              <div className={classes.personalContent}>
                Click Manage <em>My Card Sets</em> to create your first
                flashcard set.
              </div>
            )}
            <div className={classes.personalActions}>
              <Button
                className={classes.whiteButton}
                onClick={() => {
                  setIsUpdatingCardSet(false);
                  setEditingIndex(null);
                  setOpenNewCardModal(true);
                }}
              >
                <AddIcon sx={{ marginRight: '8px' }} />
                New Card Set
              </Button>
            </div>
          </Paper>
          <Paper className={classes.selectPanel}>
            <FormControl
              sx={{
                minWidth: '200px',
              }}
            >
              <InputLabel id='status-label'>Clear Set Data</InputLabel>
              <Select
                labelId='status-label'
                value={selectedOption}
                label='Clear Set Data'
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <MenuItem value={0}>----Main Sets----</MenuItem>
                <MenuItem value={1}>Practice Cards</MenuItem>
              </Select>
            </FormControl>
          </Paper>
        </Grid>
        <Grid item xs={2}>
          <Paper className={classes.helpPanel}>
            <div className={classes.helpHeader}>
              <Typography sx={{ fontSize: '14px' }}>
                <strong>Need some help?</strong>
              </Typography>
              <Typography sx={{ marginTop: '12px', fontSize: '14px' }}>
                Check out our videos to learn to navigate the FFC.
              </Typography>
              <Button
                className={classes.linkButton}
                onClick={() => navigate('/tutorials')}
              >
                <YouTubeIcon sx={{ marginRight: '4px' }} />
                Tutorial Videos
              </Button>
            </div>
            <div className={classes.helpBody}>
              <Typography sx={{ fontSize: '14px' }}>
                <strong>How often to do timings?</strong>
              </Typography>
              <Typography
                sx={{ marginTop: '12px', color: '#586065', fontSize: '14px' }}
              >
                Studies show the best results when performers practice for 15
                minutes daily. Then once you are fluent, doing weekly timings
                helps you maintain fluency for a long time.
              </Typography>
            </div>
          </Paper>
        </Grid>
      </Grid>

      <NewCardSetModal
        cardSet={isUpdatingCardSet ? cardSets[editingIndex] : null}
        open={openNewCardModal}
        isUpdating={isUpdatingCardSet}
        close={() => {
          setIsUpdatingCardSet(false);
          setOpenNewCardModal(false);
        }}
        onCreate={(title, aim) =>
          isUpdatingCardSet
            ? handleUpdateNewCardSet(title, aim)
            : handleCreateNewCardSet(title, aim)
        }
      />
    </div>
  );
};

export default Sets;
